import React from 'react';

const Phonebooks = () => {
    return (
        <div className="bg-success min-vh-100 p-4">
            dsadasd
        </div>
    );
};

export default Phonebooks;